<section class="w-screen h-screen overflow-hidden p-0 m-0 bg-zinc-950 relative">
    <div class="grid grid-cols-1 lg:grid-cols-2 h-full w-full relative z-10">
        <!-- Left Side -->
        <div class="h-full col-span-1 flex justify-center items-center">

            <div class="w-[90%] md:w-1/2 lg:w-4/5 xl:w-1/2 ">
                <!-- <span
                    class="font-mono text-lg capitalize font-semibold text-sky-400 border-sky-400 border pl-0 p-2"><span
                        class="bg-sky-400 text-black p-2 mr-2">Teacher</span>Factory <i
                        class="ri-graduation-cap-fill"></i></span> -->
                

                <p class="mt-5 text-5xl font-semibold capitalize text-white">welcome Back</p>
                <!-- <p class="mt-2 text-zinc-600">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nemo molestias
                    minima aut ad enim.</p> -->

                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="mt-5">

                    <!-- Email Field -->
                    <label class="input input-bordered flex items-center gap-2 bg-zinc-900 text-white" [ngClass]="{
                    'error': loginForm.controls['email'].invalid && loginForm.controls['email'].touched
                  }">
                        <i class="ri-mail-fill"></i>
                        <input type="text" class="grow bg-zinc-900 outline-none text-white"
                            placeholder="user@teacherfactory.com" formControlName="email" />
                    </label>
                    <small
                        *ngIf="loginForm.controls['email'].touched && loginForm.controls['email'].errors?.['required']"
                        class="text-red-500">
                        Email is required
                    </small>
                    <small *ngIf="loginForm.controls['email'].touched && loginForm.controls['email'].errors?.['email']"
                        class="text-red-500">
                        Enter a valid email
                    </small>

                    <!-- Password Field -->
                    <label class="input input-bordered flex items-center gap-2 mt-3 bg-zinc-900 text-white" [ngClass]="{
                    'error': loginForm.controls['password'].invalid && loginForm.controls['password'].touched
                  }">
                        <i class="ri-key-line"></i>
                        <input type="{{isPasswordVisible ? 'text' : 'password'}}" class="grow bg-zinc-900 outline-none text-white" placeholder="*******"
                            formControlName="password" />
                        <button type="button" class="btn btn-sm btn-circle bg-zinc-800 border-none text-zinc-500" (click)="!isPasswordVisible ? isPasswordVisible = true : isPasswordVisible = false">
                            <i class="{{isPasswordVisible ? 'ri-eye-off-line' :  'ri-eye-line'}}"></i>
                        </button>
                    </label>
                    <small
                        *ngIf="loginForm.controls['password'].touched && loginForm.controls['password'].errors?.['required']"
                        class="text-red-500">
                        Password is required
                    </small>

                    <!-- <a
                        class="cursor-pointer text-zinc-700 hover:text-zinc-500 text-sm capitalize font-semibold float-end mt-1">
                        forget password?
                    </a> -->
                    <button type="submit" class="mt-10 btn glass w-full text-white bg-sky-500 hover:bg-sky-600">
                        Login
                    </button>

                </form>


            </div>

        </div>

        <!-- Right Side with perfect 1rem padding -->
        <div class="col-span-1 h-full relative hidden lg:block">
            <div class="absolute inset-2 rounded-lg overflow-hidden">
                <img class="w-full h-full object-cover rounded-lg"
                    src="https://images.unsplash.com/photo-1737868131781-d8ca29bffdbf?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    alt="" />
            </div>
        </div>
    </div>

</section>

<!-- <app-device-modal></app-device-modal> -->
